import { useEffect, useState } from 'react';
import {
  fetchBranchApprovalWorkflow,
  type ApprovalRule,
  type ApprovalWorkflow,
} from './addBranchApi';

export type ApprovalLevel = 'none' | 'manager' | 'admin';

// null until the branch's workflow has loaded (or when it could not be loaded): the server still
// applies it when the request is saved, the form only loses its hints
export const useBranchApprovalWorkflow = (
  branch: string
): ApprovalWorkflow | null => {
  const [workflow, setWorkflow] = useState<ApprovalWorkflow | null>(null);
  useEffect(() => {
    if (branch === '' || branch === undefined) return;
    let isCurrent = true;
    fetchBranchApprovalWorkflow(branch)
      .then((data) => {
        if (isCurrent) setWorkflow(data);
      })
      .catch(() => {
        if (isCurrent) setWorkflow(null);
      });
    return () => {
      isCurrent = false;
    };
  }, [branch]);
  return workflow;
};

// Mirrors the server's rules in config/approvalWorkflow.js
export const requiredApproval = (
  rule: ApprovalRule | undefined,
  value: number
): ApprovalLevel => {
  if (rule === undefined || !(value > 0) || rule.mode === 'none') return 'none';
  if (rule.mode === 'tiered') {
    return value <= rule.managerLimit ? 'manager' : 'admin';
  }
  return rule.mode;
};

export const expectedDocumentCharge = (
  principal: number,
  ratePercent: number | undefined
): number => (Number(principal) * (ratePercent ?? 0)) / 100;

const ROUNDING_TOLERANCE = 0.005;
export const documentChargeWaiverPercent = (
  expected: number,
  charged: number
): number => {
  if (!(expected > 0) || charged >= expected - ROUNDING_TOLERANCE) return 0;
  return ((expected - charged) / expected) * 100;
};
